<template>
  <nav>
    <ul class="flex flex-wrap gap-y-2 py-3 items-center menu-font">
      <li
        v-for="item in settings?.menus?.primary"
        :key="item.id"
        class="relative group"
      >
        <!-- Main link -->
        <component
          :is="item.tag"
          :to="item.path"
          :href="item.path"
          class="px-3 py-1 mx-1 rounded-full transition-colors inline-flex items-center gap-1"
          :class="
            isActive(item.path)
              ? 'bg-yka-blue text-white'
              : 'text-yka-blue hover:bg-yka-blue-light'
          "
        >
          {{ item.title }}
          <span v-if="item.children">
            <Icon
              name="dropdown-arrow"
              class="h-4 w-4"
              :class="
                isActive(item.path)
                  ? 'bg-yka-blue text-white'
                  : 'text-yka-blue hover:bg-yka-blue-light'
              "
            />
          </span>
        </component>

        <!-- Dropdown menu -->
        <ul
          v-if="item.children"
          class="absolute left-0 top-full mt-1 hidden bg-white group-hover:block p-1 rounded shadow-md z-20 min-w-max"
        >
          <li v-for="child in item.children" :key="child.id">
            <component
              :is="child.tag"
              :to="child.path"
              :href="child.path"
              class="block px-3 py-2 my-1 text-sm rounded transition-colors"
              :class="
                isActive(child.path)
                  ? 'bg-yka-blue text-white'
                  : 'text-yka-blue hover:bg-yka-blue-light hover:text-yka-blue'
              "
            >
              {{ child.title }}
            </component>
          </li>
        </ul>
      </li>
    </ul>
  </nav>
</template>

<script>
import Settings from "@/lib/Settings";
import { useRoute } from "vue-router";
import Icon from "@/components/Icons.vue";

export default {
  name: "TopMenu",
  components: {
    Icon,
  },
  setup() {
    const route = useRoute();
    const { settings } = Settings();

    const isActive = (path) => {
      return route.path === path;
    };

    return {
      settings,
      isActive,
    };
  },
};
</script>

<style scoped>
.group:hover ul {
  display: block;
}

ul.absolute {
  margin-top: 0;
  top: 100%;
}
</style>
